import * as React from 'react';
import { useIntl } from 'react-intl';

import { AvailabilityState } from '@notino/shared/definitions/types';

import { useTagAttributes } from '@components/Universals/ProductItem/useTagAttributes';
import { Watchdog } from '@sharedComponents/Watchdog';
import { watchdogMessages } from '@sharedComponents/Watchdog/watchdogMessages';

import { ColorCirclePickerProps } from './ColorCirclePicker';
import { WatchdogLink, Tag, TagOrWatchdogWrapper } from './styled';
import { trackDrawerWatchdogClick } from './tracking';
import { isAvailableTagForShadesDrawer } from './utils';

export const ItemStatus: React.FC<
  Pick<ColorCirclePickerProps, 'item' | 'product'>
> = ({ item, product }) => {
  const { formatMessage } = useIntl();
  const tagAttributes = useTagAttributes(item.attributes, {
    multiple: false,
    customFilter: isAvailableTagForShadesDrawer,
  });
  const tagLabel = tagAttributes?.[0]?.label;
  const showWatchdog =
    item.availability.state === AvailabilityState.ShowWatchdog;

  if (!showWatchdog && !tagLabel) {
    return null;
  }

  const handleWatchdogClick = (e) => {
    e.preventDefault();
    if (product) {
      trackDrawerWatchdogClick(product, item);
    }
  };

  return (
    <TagOrWatchdogWrapper>
      {showWatchdog ? (
        <Watchdog variant={item} id={`watchdog-variant-${item.webId}`}>
          {({ watchdogActive }) => (
            <WatchdogLink onClick={handleWatchdogClick}>
              {formatMessage(
                watchdogActive
                  ? watchdogMessages.watchdogActive
                  : watchdogMessages.watchAvailability
              )}
            </WatchdogLink>
          )}
        </Watchdog>
      ) : (
        <Tag>{tagLabel}</Tag>
      )}
    </TagOrWatchdogWrapper>
  );
};
